import { render, staticRenderFns } from "./ChannelSettingsView.vue?vue&type=template&id=743798ba&scoped=true&"
import script from "./ChannelSettingsView.vue?vue&type=script&lang=js&"
export * from "./ChannelSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelSettingsView.vue?vue&type=style&index=0&id=743798ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743798ba",
  null
  
)

export default component.exports